<template>
  <authorization permissionKey="configuration_template" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Protocolos
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/protocolos/receituario">Receituário</v-tab>
            <v-tab to="/configuracoes/protocolos/terapeutica-clinica">
              Terapêutica clinica
            </v-tab>
            <v-tab to="/configuracoes/protocolos/terapeutica-cirurgica">
              Terapêutica cirúrgica
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
  export default {
    name: "TemplateConfig",
  };
</script>

<style lang="scss" scoped></style>
